import { createContext } from "react";

export type ColorModeValue = {
  mode: "light" | "dark";
  toggleMode: () => void;
};

export const ColorModeContext = createContext<ColorModeValue | null>(null);
